import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Registration } from "../../../registration/models/registration";
import { NotificationService } from '../../../shared/service/notification.service';
import CommonUtils from '../../../shared/utils/common.utils';
import { AgTeachersService } from '../../ag-teachers.service';
import { LiveStockSummary } from '../../models/liveStockSummary';

@Component({
  selector: 'app-edit-entry',
  templateUrl: './edit-entry.component.html',
  styleUrl: './edit-entry.component.scss'
})
export class EditEntryComponent implements OnInit {

  exhibitor: Registration = { liveStocks: [] };
  liveStockSummary: LiveStockSummary = {};
  isLoading = true;
  isValidated = false;
  exhibitorId!: number;
  orgId!: number;
  chapterId!: number;

  @ViewChildren(OverlayPanel) overlayPanels!: QueryList<OverlayPanel>;

  constructor(
    private readonly agTeacherServices: AgTeachersService,
    private readonly confirmationService: ConfirmationService,
    private readonly notificationService: NotificationService,
    private readonly route: ActivatedRoute,
    private readonly routes: Router
  ) { }

  ngOnInit(): void {
    this.exhibitorId = Number(this.route.snapshot.paramMap.get("id"));
    this.orgId = Number(sessionStorage.getItem("orgId"));
    this.chapterId = Number(sessionStorage.getItem("chapterId"));

    this.getExhibitor();
    this.getSummary();
  }

  getExhibitor() {
    this.agTeacherServices.getExhibitor(this.orgId, this.exhibitorId).subscribe({
      next: response => {
        if (response) {
          this.exhibitor = response;
          this.isValidated = this.exhibitor.status != null && !CommonUtils.equalsIgnoreCase('Submitted', this.exhibitor.status);
        }
      },
      error: err => {
        this.notificationService.error(err);
      }
    });
  }

  getSummary() {
    const params = {
      id: this.exhibitorId,
      orgId: this.orgId
    };

    this.agTeacherServices.liveStockSummary(params).subscribe({
      next: response => {
        if (response) {
          this.liveStockSummary = response;
          this.isLoading = false;
        }
      },
      error: err => {
        this.notificationService.error(err);
      }
    });
  }

  approveExhibitor() {
    this.confirmationService.confirm({
      header: 'Approve Confirmation',
      message: 'Do you want to approve this exhibitor?',
      defaultFocus: 'none',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button",
      rejectButtonStyleClass: "p-button-outlined p-button-danger",
      acceptIcon: "none",
      rejectIcon: "none",
      accept: () => {
        const params = {
          id: this.exhibitorId,
          chapterId: this.chapterId,
          comments: encodeURIComponent(this.exhibitor.approvalComments ?? '')
        };

        this.agTeacherServices.approveExhibitor(params).subscribe({
          next: response => {
            this.notificationService.success({ message: 'Exhibitor has been approved!' });
            this.back();
          },
          error: err => {
            this.notificationService.error(err);
          }
        });
      }
    });
  }

  approveWithConditions() {
    this.confirmationService.confirm({
      header: 'Approve with Conditions Confirmation',
      message: 'Do you want to approve this exhibitor with conditions?',
      defaultFocus: 'none',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button",
      rejectButtonStyleClass: "p-button-outlined p-button-danger",
      acceptIcon: "none",
      rejectIcon: "none",
      accept: () => {
        const params = {
          id: this.exhibitorId,
          chapterId: this.chapterId,
          comments: encodeURIComponent(this.exhibitor.approvalComments ?? '')
        };

        this.agTeacherServices.approveExhibitorWithConditions(params).subscribe({
          next: response => {
            console.log(response, "ok-approve exhibitor with conditions");
            this.notificationService.success({ message: 'Exhibitor has been approved with conditions!' });
            this.back();
          },
          error: err => {
            this.notificationService.error(err);
          }
        });
      }
    });
  }

  rejectExhibitor() {
    this.confirmationService.confirm({
      header: 'Reject Confirmation',
      message: 'Do you want to reject this exhibitor?',
      defaultFocus: 'none',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button",
      rejectButtonStyleClass: "p-button-outlined p-button-danger",
      acceptIcon: "none",
      rejectIcon: "none",
      accept: () => {
        const params = {
          id: this.exhibitorId,
          chapterId: this.chapterId,
          comments: encodeURIComponent(this.exhibitor.approvalComments ?? '')
        };

        this.agTeacherServices.rejectExhibitor(params).subscribe({
          next: response => {
            this.notificationService.success({ message: 'Exhibitor has been rejected!' });
            this.back();
          },
          error: err => {
            this.notificationService.error(err);
          }
        });
      }
    });
  }

  ReportedIssueExhibitor() {
    this.confirmationService.confirm({
      header: 'Report Issue Confirmation',
      message: 'Do you want to report issue for this exhibitor?',
      defaultFocus: 'none',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button",
      rejectButtonStyleClass: "p-button-outlined p-button-danger",
      acceptIcon: "none",
      rejectIcon: "none",
      accept: () => {
        const params = {
          id: this.exhibitorId,
          chapterId: this.chapterId,
          comments: encodeURIComponent(this.exhibitor.approvalComments ?? '')
        };

        this.agTeacherServices.ReportedIssueExhibitor(params).subscribe({
          next: response => {
            this.notificationService.success({ message: 'Issue reported for exhibitor!' });
            this.back();
          },
          error: err => {
            this.notificationService.error(err);
          }
        });
      }
    });
  }

  back() {
    this.routes.navigate(["/ag-teachers/entries"]);
  }

  showOverlayPanel(event: Event, index: number) {
    const overlayPanel = this.overlayPanels.toArray()[index];
    if (overlayPanel) {
      overlayPanel.toggle(event);
    }
  }

  getSubClassName = CommonUtils.getSubClassName;

}
